import httpClient from "../Core/http";

class MachineInfo_Api {
  getMachineInfo(params: any): Promise<any> {
    let url = "machine/info";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
    getMachineInfoBySerial(params: any): Promise<any> {
        let url = "machine/infoBySerial";
        return new Promise((resolve, reject) => {
            httpClient
                .get<any[]>(url, { params: params })
                .then((response: any) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                    console.log(error);
                });
        });
    }
  getProjectNumber(params: any, signal: any): Promise<any> {
    let url = "machine/projectNumber";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params, signal: signal })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
  getMachineCardHistory(params: any): Promise<any> {
    let url = "machine/history";
    return new Promise((resolve, reject) => {
      httpClient
        .get<any[]>(url, { params: params })
        .then((response: any) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
          console.log(error);
        });
    });
  }
}

export const MachineInfoApi = new MachineInfo_Api();
